import { render, staticRenderFns } from "./LeaderboardLong.vue?vue&type=template&id=22b5a0ee&scoped=true"
import script from "./LeaderboardLong.vue?vue&type=script&lang=js"
export * from "./LeaderboardLong.vue?vue&type=script&lang=js"
import style0 from "./LeaderboardLong.vue?vue&type=style&index=0&id=22b5a0ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b5a0ee",
  null
  
)

export default component.exports